<template>
  <div class="wrapper">
    <MainNavbar />
    <zoom-center-transition :duration="200" mode="out-in">
      <router-view />
    </zoom-center-transition>
    <MainFooter />
    <modal v-if="showLogin">
      <template slot="header">
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeLogin"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <login></login>
      </template>
    </modal>

    <modal v-if="showSignup">
      <template slot="header">
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeSignup"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <register></register>
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal } from "@/components";
import Login from "./Landing/Login.vue";
import Register from "./Landing/Register.vue";
import { mapFields } from "vuex-map-fields";
import MainFooter from "./Landing/Layout/MainFooter.vue";
import MainNavbar from "./Landing/Layout/SmallNavigationSection.vue";
import { EventBus } from "@/helpers";
import swal from "sweetalert2";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    Modal,
    Login,
    MainFooter,
    MainNavbar,
    Register,
    ZoomCenterTransition
  },
  name: "index",
  bodyClass: "index-page",
  props: {
    logoImg: {
      type: String,
      default: "./img/logo-inverted.png"
    },
    img: {
      type: String,
      default: "./img/default-avatar.png"
    }
  },
  data() {
    return {
      showLogin: false,
      showSignup: false
    };
  },
  computed: {
    ...mapFields("auth", ["loggedOn"])
  },
  methods: {
    login() {
      this.showLogin = true;
    },
    closeLogin() {
      this.showLogin = false;
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
    signup() {
      this.showSignup = true;
    },
    closeSignup() {
      this.showSignup = false;
    }
  },
  mounted() {
    EventBus.$on("signedup", () => {
      this.showSignup = false;
      swal.fire({
        title: this.$t("Thank You"),
        text: this.$t(
          "You successfully signed up. Please check your email to activate your account!"
        ),
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
    });
  },
  beforeDestroy() {
    EventBus.$off("signedup");
  }
};
</script>

<style lang="scss"></style>
